<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="rem-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🏡 DISTRIBUTED OPERATIONS</div>
      <h1>Engage and Manage<br>Your <span style="color:#6EE7B7;">Remote Team</span></h1>
      <p>From flexible home-office stipends to geo-synced clocks and remote resource compliance checklists — optimized for fully distributed talent.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-primary" style="background:#15803d;">Scale Remote HR</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.35);">View Equipment Integrations</a>
      </div>
    </div>
    <div>
      <div class="stipend-widget">
        <div class="stipend-widget-title">Stipend Claim Hub</div>
        <div class="stipend-list">
          <div class="stipend-row"><span>Home Broadband</span><span class="stipend-val">$50 / mo Claimed</span></div>
          <div class="stipend-row"><span>Ergonomic Desk Chair</span><span class="stipend-val">$250 Approved</span></div>
          <div class="stipend-row"><span>Learning &amp; Books Allowance</span><span class="stipend-val">$120 Claimed</span></div>
          <div class="stipend-row"><span>Monitor &amp; Peripherals</span><span class="stipend-val">$400 Pending</span></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- TIMEZONE COORDINATION -->
<section class="tz-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🕒 Asynchronous Coordination</span>
      <h2 class="sec-h2">Time-Zone Sync<br><span class="gradient-text">Made Seamless</span></h2>
      <p class="sec-sub">Track real-time working status and overlap windows across all employee offsets at a glance.</p>
    </div>
    <div class="tz-grid">
      <div class="tz-card"><div class="tz-time">10:42 AM</div><div class="tz-city">New York</div><div class="tz-offset">EST (UTC −5)</div></div>
      <div class="tz-card"><div class="tz-time">03:42 PM</div><div class="tz-city">London</div><div class="tz-offset">GMT (UTC +0)</div></div>
      <div class="tz-card"><div class="tz-time">09:12 PM</div><div class="tz-city">Bangalore</div><div class="tz-offset">IST (UTC +5:30)</div></div>
      <div class="tz-card"><div class="tz-time">11:42 PM</div><div class="tz-city">Singapore</div><div class="tz-offset">SGT (UTC +8)</div></div>
    </div>
  </div>
</section>

<!-- EQUIPMENT HUB -->
<section class="equipment-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🖥️ Equipment &amp; Stipend Management</span>
      <h2 class="sec-h2">Every Employee's Desk,<br><span class="gradient-text">Tracked &amp; Budgeted</span></h2>
      <p class="sec-sub">Manage home-office equipment requests, approvals, and reimbursements from one centralized hub.</p>
    </div>
    <div class="equipment-grid">
      <div class="equipment-card">
        <div class="equipment-card__icon">💻</div>
        <div>
          <div class="equipment-card__title">Laptop &amp; Workstation</div>
          <div class="equipment-card__desc">Provision hardware directly to employee addresses. Track asset lifecycles and handle refresh cycles automatically.</div>
          <div class="equipment-card__amount">Up to $1,500 budget</div>
        </div>
      </div>
      <div class="equipment-card">
        <div class="equipment-card__icon">🪑</div>
        <div>
          <div class="equipment-card__title">Ergonomic Furniture</div>
          <div class="equipment-card__desc">Employees submit chair, desk, and monitor requests with pre-approved vendor links — HR approves in one click.</div>
          <div class="equipment-card__amount">Up to $400 budget</div>
        </div>
      </div>
      <div class="equipment-card">
        <div class="equipment-card__icon">📡</div>
        <div>
          <div class="equipment-card__title">Internet &amp; Utilities</div>
          <div class="equipment-card__desc">Monthly broadband reimbursements processed alongside payroll — no manual expense reports needed.</div>
          <div class="equipment-card__amount">Up to $80 / month</div>
        </div>
      </div>
      <div class="equipment-card">
        <div class="equipment-card__icon">🎧</div>
        <div>
          <div class="equipment-card__title">Peripherals &amp; Audio</div>
          <div class="equipment-card__desc">Headsets, webcams, microphones — employees pick from approved catalog and assets are tracked in inventory.</div>
          <div class="equipment-card__amount">Up to $200 budget</div>
        </div>
      </div>
      <div class="equipment-card">
        <div class="equipment-card__icon">📚</div>
        <div>
          <div class="equipment-card__title">Learning Allowance</div>
          <div class="equipment-card__desc">Fund online courses, books, and certifications automatically with annual learning budgets per department.</div>
          <div class="equipment-card__amount">Up to $600 / year</div>
        </div>
      </div>
      <div class="equipment-card">
        <div class="equipment-card__icon">🏥</div>
        <div>
          <div class="equipment-card__title">Wellness Benefits</div>
          <div class="equipment-card__desc">Gym memberships, mental health apps, and meditation tool subscriptions — fully reimbursable and policy-enforced.</div>
          <div class="equipment-card__amount">Up to $50 / month</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- WORK MODES -->
<section class="work-modes-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🔄 Flexible Work Policies</span>
      <h2 class="sec-h2">Configure Any<br><span class="gradient-text">Work Arrangement</span></h2>
      <p class="sec-sub">Support every modern work mode — from fully remote to hybrid and in-office rotations — with built-in policy enforcement.</p>
    </div>
    <div class="work-modes-grid">
      <div class="work-mode-card">
        <div class="work-mode-card__icon">🏡</div>
        <div class="work-mode-card__title">Fully Remote</div>
        <div class="work-mode-card__desc">No office? No problem. Full stipend management, async check-ins, and geolocation-agnostic payroll for 100% distributed teams.</div>
      </div>
      <div class="work-mode-card">
        <div class="work-mode-card__icon">🏢</div>
        <div class="work-mode-card__title">Hybrid Split</div>
        <div class="work-mode-card__desc">Define in-office days per team or role, track desk bookings, and measure hybrid attendance automatically without friction.</div>
      </div>
      <div class="work-mode-card">
        <div class="work-mode-card__icon">✈️</div>
        <div class="work-mode-card__title">Work From Anywhere</div>
        <div class="work-mode-card__desc">Support digital nomad policies with country-duration rules, tax exposure tracking, and automatic compliance alerts.</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="remote-cta">
  <div class="container-wrapper">
    <h2 class="remote-cta__h2">Your Remote Team Deserves<br>World-Class HR</h2>
    <p class="remote-cta__p">Join 2,100+ distributed companies using NeoHRMZ to manage remote workforces efficiently and compliantly.</p>
    <div class="remote-cta__actions">
      <a href="#" class="btn btn-white">Start Free Trial</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Schedule a Demo</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>